<script lang="ts">
  import { getLayerDef } from '../map/layers/registry'
  import { layers } from '../state/layers.svelte'
  import Icon from './Icon.svelte'

  /**
   * The active-layer chip over the map (Phase 11 plan §5.2, §7): the first
   * layer in bold, then the next one or a count, muted. A tap opens the layer
   * stack. Nothing on, no chip. Placed by the layout.
   */

  let { onOpen }: { onOpen: () => void } = $props()

  let chip = $derived.by(() => {
    const labels = layers.active.map((id) => getLayerDef(id)?.label ?? id)
    if (labels.length === 0) return null
    const more =
      labels.length === 1 ? '' : labels.length === 2 ? `+ ${labels[1]}` : `+ ${labels.length - 1} more`
    return { first: labels[0], more }
  })
</script>

{#if chip}
  <button type="button" class="active-chip touch-target" onclick={onOpen}>
    <Icon name="layers" size={16} />
    <b>{chip.first}</b>{#if chip.more}<span class="more">{chip.more}</span>{/if}
  </button>
{/if}

<style>
  .active-chip {
    max-width: 100%;
    height: var(--active-chip-h, 38px);
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 var(--active-chip-px, 12px);
    border: 0;
    background: var(--color-bg);
    box-shadow: var(--float-shadow);
    color: var(--color-text);
    font-size: var(--active-chip-fs, 14px);
    white-space: nowrap;
    cursor: pointer;
  }

  .active-chip :global(svg) {
    flex: none;
  }

  b {
    font-weight: 800;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .more {
    color: var(--color-muted);
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
